import beforeForm from './before-form'

export { beforeForm }

export default { beforeForm }
